"use strict";
// The Security screen: where this account is signed in, and ending one of
// those.
//
// Every row is a real session from GET /me/sessions. There is no security
// score, no risk rating and no "last password change" — none of those exist
// in this system, and a screen about safety is the worst place to show a
// number that was made up.
(function () {
    function t(hubEl, key, fallback) {
        return hubEl.dataset[key] || fallback;
    }
    var esc = function (value) {
        return window.FlixHubFormat.escapeHtml(value);
    };
    var SHIELD_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><polyline points="9 12 11 14 15 9.5"/></svg>';
    /** Handset. */
    var PHONE_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2.5" width="16" height="19" rx="3"/><line x1="10" y1="18.5" x2="14" y2="18.5"/></svg>';
    /** Laptop / desktop. */
    var LAPTOP_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="12" rx="2"/><line x1="1.5" y1="20" x2="22.5" y2="20"/></svg>';
    /** Tablet — a handset's proportions are wrong for one, and a laptop's lid is wronger. */
    var TABLET_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2.5"/><line x1="10.5" y1="18" x2="13.5" y2="18"/></svg>';
    /**
     * Picks the glyph from the platform already named in the description.
     *
     * `deviceDescription` is derived server-side from the User-Agent and
     * reads like "Chrome on Windows", so the platform word is all that is
     * needed — nothing new is asked of the backend. A session we cannot
     * place keeps the neutral handset rather than being guessed at.
     */
    function deviceIcon(description) {
        var d = (description || "").toLowerCase();
        if (/ipad|tablet/.test(d))
            return TABLET_ICON;
        if (/iphone|android|mobile|phone/.test(d))
            return PHONE_ICON;
        if (/windows|mac os|macos|linux|chrome os|chromeos|desktop/.test(d))
            return LAPTOP_ICON;
        return PHONE_ICON;
    }
    /** The section label the Hub uses everywhere: mono 10px, 2px tracking. */
    function sectionLabelHtml(label) {
        return ('<div style="font-family:var(--mono);font-size:10px;letter-spacing:2px;color:var(--accent);margin:0 0 10px;text-transform:uppercase">' +
            esc(label) +
            "</div>");
    }
    /**
     * "Active now" rather than a timestamp for anything within the last few
     * minutes: on the device you are holding, a clock reading two minutes ago
     * is noise, and the thing that matters is whether a row is you.
     */
    function lastSeenLabel(hubEl, iso, locale) {
        var seen = new Date(iso).getTime();
        if (Number.isNaN(seen))
            return "";
        var minutes = Math.floor((Date.now() - seen) / 60000);
        if (minutes < 5)
            return t(hubEl, "i18nSecurityActiveNow", "Active now");
        return window.FlixHubFormat.date(iso, locale);
    }
    function sessionRowHtml(hubEl, session, locale) {
        var description = session.deviceDescription ||
            t(hubEl, "i18nSecurityUnknownDevice", "Unrecognised device");
        var currentPill = session.isCurrentDevice
            ? '<span style="display:inline-flex;align-items:center;flex:none;padding:3px 9px;border-radius:var(--radius-lg);' +
                "background:color-mix(in srgb, var(--success) 12%, transparent);border:1px solid color-mix(in srgb, var(--success) 38%, transparent);color:color-mix(in srgb, var(--success) 78%, #ffffff);" +
                'font-size:11px;font-weight:700">' +
                esc(t(hubEl, "i18nSecurityThisDevice", "This device")) +
                "</span>"
            : "";
        // The current device has no per-row sign-out: ending it here would sign
        // you out mid-action from a screen whose whole job is the OTHER rows.
        // The Sign out control in the rail is where that belongs.
        var action = session.isCurrentDevice
            ? ""
            : '<button type="button" data-flix-security-revoke="' +
                esc(session.sessionId) +
                '" style="flex:none;background:none;border:1px solid var(--border);border-radius:10px;' +
                "padding:7px 13px;color:var(--error);font-family:var(--body);font-size:13px;font-weight:700;" +
                'cursor:pointer;transition:border-color .2s" style-hover="border-color:var(--error)">' +
                esc(t(hubEl, "i18nSecuritySignOutDevice", "Sign out")) +
                "</button>";
        return ('<div data-flix-security-session style="display:flex;align-items:center;gap:13px;padding:14px 16px;' +
            'border-bottom:1px solid var(--border)">' +
            '<span aria-hidden="true" style="width:38px;height:38px;flex:none;border-radius:11px;background:var(--surface2);' +
            'display:flex;align-items:center;justify-content:center;color:var(--dim)">' +
            deviceIcon(session.deviceDescription) +
            "</span>" +
            '<div style="flex:1;min-width:0">' +
            '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">' +
            '<span style="font-size:14px;font-weight:700;color:var(--text)">' +
            esc(description) +
            "</span>" +
            currentPill +
            "</div>" +
            '<div style="font-size:12px;color:var(--dim);margin-top:2px">' +
            esc(lastSeenLabel(hubEl, session.lastSeenAt, locale)) +
            "</div>" +
            "</div>" +
            action +
            "</div>");
    }
    async function render(hubEl, contentEl) {
        var locale = document.documentElement.lang || "en";
        contentEl.innerHTML = window.FlixHubRender.loadingState(t(hubEl, "i18nLoading", "Loading…"));
        var page;
        try {
            page = await window.FlixAuthClient.listSessions();
        }
        catch (err) {
            contentEl.innerHTML = window.FlixHubRender.errorState({
                title: t(hubEl, "i18nErrorTitle", "Something went wrong"),
                message: t(hubEl, "i18nErrorMessage", "We couldn't load your account. Please try again."),
                retryLabel: t(hubEl, "i18nRetry", "Retry"),
            });
            window.flixCompileHoverStyles(contentEl);
            return;
        }
        if (page.sessions.length === 0) {
            // Reaching this screen means being signed in, so an empty list is a
            // system that has lost track rather than a normal state — say so
            // plainly instead of pretending it is fine.
            contentEl.innerHTML = window.FlixHubRender.emptyState({
                title: t(hubEl, "i18nSecurityEmptyTitle", "No active sessions"),
                message: t(hubEl, "i18nSecurityEmptyMessage", "We couldn't find anywhere this account is currently signed in."),
                iconSvg: SHIELD_ICON,
            });
            window.flixCompileHoverStyles(contentEl);
            return;
        }
        contentEl.innerHTML =
            sectionLabelHtml(t(hubEl, "i18nSecuritySessionsLabel", "Where you're signed in")) +
                '<div data-flix-security-list style="border-radius:var(--radius-md);background:var(--surface);' +
                'border:1px solid var(--border);overflow:hidden">' +
                page.sessions.map((s) => sessionRowHtml(hubEl, s, locale)).join("") +
                "</div>" +
                '<p style="font-size:12px;color:var(--faint);margin:12px 2px 0;line-height:1.6">' +
                esc(t(hubEl, "i18nSecurityHint", "Signing out a device ends its session immediately.")) +
                "</p>";
        // The last row's divider would otherwise draw a line against the card's
        // own border.
        var rows = contentEl.querySelectorAll("[data-flix-security-session]");
        var last = rows[rows.length - 1];
        if (last)
            last.style.borderBottom = "none";
        window.flixCompileHoverStyles(contentEl);
    }
    /** Ends one session, then re-reads the list rather than trusting local state. */
    async function revoke(hubEl, contentEl, sessionId) {
        var button = contentEl.querySelector('[data-flix-security-revoke="' + sessionId.replace(/"/g, '\\"') + '"]');
        if (button) {
            button.disabled = true;
            button.style.opacity = "0.6";
        }
        try {
            await window.FlixAuthClient.revokeSession(sessionId);
        }
        catch (err) {
            if (button) {
                button.disabled = false;
                button.style.opacity = "";
            }
            return;
        }
        await render(hubEl, contentEl);
    }
    window.FlixHubSecurity = { render: render, revoke: revoke };
})();
